import { useEffect, useState } from "react";

// Live countdown to a target epoch (ms). Updates once per second; stops at 0.
// Returns the remaining seconds; null when no target is provided.
export function useCountdown(targetMs: number | null): number | null {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    if (targetMs == null) return;
    const id = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(id);
  }, [targetMs]);
  if (targetMs == null) return null;
  return Math.max(0, Math.floor((targetMs - now) / 1000));
}

export function fmtCountdown(secs: number | null): string {
  if (secs == null) return "—";
  const m = Math.floor(secs / 60);
  const s = secs % 60;
  return `${String(m).padStart(2, "0")}:${String(s).padStart(2, "0")}`;
}
